import { render, staticRenderFns } from "./playerTotalData.vue?vue&type=template&id=b78e3df2&"
import script from "./playerTotalData.vue?vue&type=script&lang=js&"
export * from "./playerTotalData.vue?vue&type=script&lang=js&"
import style0 from "./playerTotalData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports